import React from 'react';
import { Grid } from 'semantic-ui-react';
import { formatCurrency } from '../../../../../../utils/currency';
import './ItemNotAvailableAdjustment.css';
var defaultProps = {};
export default function ItemNotAvailableAdjustment(_ref) {
  var price = _ref.price;
  return /*#__PURE__*/React.createElement(Grid, {
    className: "item-not-available-adjustment"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 16,
    textAlign: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, formatCurrency(+price), " "), /*#__PURE__*/React.createElement("div", {
    className: "no-longer-available"
  }, "No longer available")));
}
ItemNotAvailableAdjustment.defaultProps = defaultProps;